module.exports = __webpack_public_path__ + "img/Blog5.6.a9c82477.png";